import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasAutoOpened, setHasAutoOpened] = useState(false);
  const whatsappUrl = 'https://wa.me/971569308158?text=Hi%2C%20I%27m%20interested%20in%20learning%20more%20about%20Dubai%20real%20estate%20investment%20opportunities.';
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasAutoOpened) {
        setIsOpen(true);
        setHasAutoOpened(true);
      }
    }, 120000);
    return () => clearTimeout(timer);
  }, [hasAutoOpened]);
  const togglePopup = () => {
    setIsOpen(!isOpen);
    setHasAutoOpened(true); // Prevent auto-open if user manually interacts before 5s
  };
  const currentTime = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex flex-col items-end" data-id="element-502">
      <AnimatePresence data-id="element-503">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="mb-3 md:mb-4 w-[270px] md:w-[320px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col origin-bottom-right border border-gray-100" data-id="element-504">
            {/* Header */}
            <div className="bg-[#1a2e1c] p-4 flex items-center justify-between relative" data-id="element-505">
              <div className="flex items-center gap-3" data-id="element-506">
                <div className="relative" data-id="element-507">
                  <img src="https://cdn.magicpatterns.com/uploads/hxjNzUvvoz4U495p4dycdL/file_(1).jpg" alt="Naina Arora" className="w-12 h-12 rounded-full object-cover border-2 border-white/20" data-id="element-508" />
                  <div className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-[#25D366] border-2 border-[#1a2e1c] rounded-full" data-id="element-509"></div>
                </div>
                <div data-id="element-510">
                  <h3 className="text-white font-semibold text-base leading-tight" data-id="element-511">
                    Naina Arora
                  </h3>
                  <p className="text-white/70 text-xs mt-0.5" data-id="element-512">Online</p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/50 hover:text-white transition-colors p-1 absolute top-3 right-3" aria-label="Close chat" data-id="element-513">
                <X className="w-5 h-5" data-id="element-514" />
              </button>
            </div>

            {/* Chat Area */}
            <div className="p-5 bg-[#efeae2] relative" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d8a34d' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} data-id="element-515">
              <div className="bg-white rounded-2xl rounded-tl-none p-3 shadow-sm relative max-w-[90%]" data-id="element-516">
                {/* Chat bubble tail */}
                <div className="absolute top-0 -left-2 w-4 h-4 bg-white" style={{
              clipPath: 'polygon(100% 0, 0 0, 100% 100%)'
            }} data-id="element-517"></div>

                <p className="text-[#1a2e1c] font-medium text-xs mb-1" data-id="element-518">
                  Naina Arora
                </p>
                <p className="text-gray-800 text-sm whitespace-pre-wrap leading-relaxed" data-id="element-519">
                  Hello!
                  <br data-id="element-520" />
                  <br data-id="element-521" />
                  Please watch the video to know more on Dubai Off Plan
                  Investments
                </p>
                <div className="text-right mt-1" data-id="element-522">
                  <span className="text-[10px] text-gray-400 font-medium" data-id="element-523">
                    {currentTime}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer CTA */}
            <div className="p-4 bg-white border-t border-gray-100" data-id="element-524">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition-colors shadow-md shadow-[#25D366]/20" data-id="element-525">
                <img src="https://cdn.magicpatterns.com/uploads/5uwA9g1pCGkLA795bDRJ8M/whatsapp_(1)_1.svg" alt="WhatsApp" className="w-5 h-5 object-contain" data-id="element-526" />
                WhatsApp Us to Book A Call
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Floating Button */}
      <button onClick={togglePopup} className="relative w-16 h-16 md:w-14 md:h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200 group focus:outline-none" aria-label="Toggle WhatsApp chat" data-id="element-527">
        <img src="https://cdn.magicpatterns.com/uploads/5uwA9g1pCGkLA795bDRJ8M/whatsapp_(1)_1.svg" alt="WhatsApp" className="w-8 h-8 md:w-7 md:h-7 object-contain relative z-10" data-id="element-528" />
        {/* Pulse animation */}
        {!isOpen && <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" data-id="element-529"></span>}

        {/* Unread badge (only show if closed and hasn't auto-opened yet) */}
        {!isOpen && !hasAutoOpened && <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 border-2 border-white rounded-full z-20" data-id="element-530"></span>}
      </button>
    </div>;
};